import React, { useContext, useState } from "react";
import "../../App.css";
import "../../styles/Footer.css";
import { Modal, Button } from "react-bootstrap";
import facebook from "../../assets/footer/facebook.svg";
import twitter from "../../assets/footer/twitter.svg";
import linkedin from "../../assets/footer/linkedin.svg";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";
const Footer = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const cookie_url = process.env.REACT_APP_FOOTER_COOKIE;
  const { language } = useContext(LanguageContext);
  return (
    // <Container fluid>
    <footer className={`footer ${language === "ARABIC" ? "rtl" : ""}`}>
      <div className="footerGrid">
        <div className="footer_section">
          <h5>{TEXT[language]["FOOTER"]["0"]}</h5>
          <ul>
            <li>
              <a href="https://www.tata.com/about-us" target="_blank">
                {TEXT[language]["FOOTER"]["1"]}
              </a>
            </li>
            <li>
              <a href="https://www.tcs.com/about-us" target="_blank">
                {TEXT[language]["FOOTER"]["2"]}
              </a>
            </li>
          </ul>
        </div>
        <div className="footer_section">
          <h5>{TEXT[language]["FOOTER"]["3"]}</h5>
          <ul>
            <li>
              {TEXT[language]["FOOTER"]["4"]}
              <br />
              <a
                href="mailto: tcs.sustainathon@tcs.com"
                target="_blank"
                style={{ textDecoration: "underline" }}
              >
                tcs.sustainathon@tcs.com
              </a>
            </li>
          </ul>
        </div>
        <div className="footer_section">
          <h5>{TEXT[language]["FOOTER"]["5"]}</h5>
          <ul>
            <li>
              <a
                href={cookie_url}
                style={{ cursor: "pointer" }}
                target="_blank"
              >
                {TEXT[language]["FOOTER"]["6"]}
              </a>
            </li>
            <li>
              <a href="https://www.tcs.com/privacy-policy" target="_blank">
                {TEXT[language]["FOOTER"]["7"]}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h5>{TEXT[language]["FOOTER"]["8"]}</h5>
          <ul className="social-medias">
            <li>
              <a
                href="https://www.facebook.com/TataConsultancyServices"
                target="_blank"
                style={{ cursor: "pointer" }}
                className="socIcon"
              >
                <img src={facebook} alt="facebook" width="18" height="18"></img>
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/tata-consultancy-services/mycompany/"
                style={{ cursor: "pointer" }}
                target="_blank"
                className="socIcon"
              >
                <img src={linkedin} alt="linkedin" width="18" height="18"></img>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/TCS"
                target="_blank"
                style={{ cursor: "pointer" }}
                className="socIcon"
              >
                <img src={twitter} alt="twitter" width="23" height="23"></img>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="copyright ltr">
        {`©${new Date().getFullYear()} Tata Consultancy Services Limited. All Rights Reserved.`}
      </div>
    </footer>
  );
};

export default Footer;
